import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  preference: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: null,
  },
};

export const PostPreferenceSlice = createSlice({
  name: "postPreference",
  initialState: INITIAL_STATE,
  reducers: {
    postPreferenceData: (state) => {
      state.preference.isLoading = true;
    },
    postPreferenceSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      preference: {
        ...state.preference,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    postPreferenceFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      preference: {
        ...state.preference,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
  },
});

export const {
  postPreferenceData,
  postPreferenceFailure,
  postPreferenceSuccess,
} = PostPreferenceSlice.actions;
export const PostPreferenceReducer = PostPreferenceSlice.reducer;
